import React, { FC, useState } from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import GlobalStyles from "../styles/GlobalStyles";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";

//Styles

interface Props {
  value?: string;
  error: boolean;
  label: string;
  helperText: string;
  maxLength?: number;
  typeId?: string;
  focusedColor?: string;
  underlineColor?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, data?: any) => void;
}

const TextFieldPassword: FC<Props> = (p) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        width: "100%",
        marginBottom: theme.spacing(1),
        "& label.Mui-focused": {
          color: p.focusedColor || GlobalStyles.secondaryColor,
        },
        "& label": {
          color: GlobalStyles.thirdColor,
        },
        "& .MuiInput-underline:after": {
          borderBottomColor: p.underlineColor || GlobalStyles.secondaryColor,
        },
        "& .MuiInput-underline:before": {
          borderBottomColor: GlobalStyles.thirdColor,
        },
        "& label.Mui-error": {
          color: GlobalStyles.primaryColor,
        },
      },
    })
  );
  const inputProps = {
    maxLength: p.maxLength ? p.maxLength : 50,
  };
  const classes = useStyles();
  return (
    <>
      <TextField
        InputProps={{
          // <-- This is where the toggle button is added.
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        value={p.value}
        label={p.label}
        error={p.error}
        type={showPassword ? "text" : "password"}
        helperText={p.helperText}
        className={classes.root}
        onChange={p.onChange}
      />
    </>
  );
};

export default TextFieldPassword;
